<template>
    <div class="pd15">
        <a-row class="">
            <div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex items-center">
                    <img class="ml15 mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <div class="ml0 fs14" style="color:grey">材料库存统计表</div>
                </div>
            </div>
        </a-row>
        <div class="bg-white">
            <a-row class="flex">
                <div class="flex items-center">
                    <a-input size="small" allowClear class="mt20 mb10 ml15 mr10" v-model="search" placeholder="请输入项目名称/物资名称" style="width: 300px" enter-button @change="allowCostClear" @search="onSearch" @pressEnter="onSearch" />
                </div>
                <a-month-picker size="small" class="mt20" placeholder="选择月份" valueFormat="chooseMonth" @change="onMonthChange" />
                <a-button size="small" class="mt20 ml10" type="primary" icon="search" @click="onSearch">
                    查询
                </a-button>
            </a-row>
            <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                <a-table :data-source="data" :columns="columns" class="pd15 w100" size="small" :pagination="false" bordered>
                    <span slot="operation" slot-scope="text, record">
                    </span>
                    <template slot="count" slot-scope="text, record">
                        <a-progress :percent="record.count ? record.count : completion" :show-info="false" size="small" :status="normal" />
                    </template>
                </a-table>
                <a-pagination 
                    class="flex items-center mb10"
                    style="justify-content: flex-end"
                    show-quick-jumper  
                    v-model="page.page" 
                    :total="page.total" 
                    :page-size="30"
                    @change="getMaterialMonthInventory" 
                />
            </a-card>

        
        </div>
       
    </div>
</template>
<script>
    export default {
        components: {

        },
        data() {
            return {
                chooseMonth:"",
                columns: [
                    {
                        title: '项目名称',
                        dataIndex: 'project_name',
                        key: 'name',
                        width: '15%',
                    },
                    {
                        title: '物资名称',
                        dataIndex: 'material_name',
                        key: 'area',
                        width: '15%',
                    },
                    {
                        title: '品牌',
                        dataIndex: 'brand',
                        key: 'brand',
                        ellipsis: true,
                    },
                    {
                        title: '规格',
                        dataIndex: 'size',
                        key: 'size',
                        ellipsis: true,
                    },
                    {
                        title: '单位',
                        dataIndex: 'unit',
                        key: 'unit',
                        ellipsis: true,
                    },
                    {
                        title: '月末余量',
                        dataIndex: 'count',
                        key: 'count',
                        width: '10%',

                    },
                    {
                        title: '月份',
                        dataIndex: 'month',
                        key: 'month',
                    },
                ],
                data:[],
                page:{
                    page:1,
                    total:0
                },
                search:"",
            }
        },
        created(){
            this.getMaterialMonthInventory()
        },
        methods:{
            async getMaterialMonthInventory(){
                let rs = await this.$api.getMaterialMonthInventory(this.search, this.page.page - 1, 30, this.chooseMonth)
                console.log(rs)
                if(rs.err == 0){
                    this.page.total = rs.count
                    this.data = rs.data
                }
            },
            onMonthChange(date, dateString){
                this.chooseMonth = dateString
            },
            onSearch(){
                this.page.page = 1
                this.getMaterialMonthInventory()
            },
            allowCostClear(){
                if(this.search.length == 0){
                    this.page.page = 1;
                    this.getMaterialMonthInventory()
                }
            }
        }

    }

</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
  